import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate ,useParams} from "react-router-dom";
import { getVehicleProfileData,getKarzaVehicleData, getServiceItems, advancedVehicleListAction } from "../../services/Store/Actions/fleetActions";
import DocumentsAndPermits from "./documents";
import ServiceAndMaintainance from "./service";
import DriverHistory from "./driverHistory";
import Tools from "./tools";
import { ToastContainer } from "react-toastify";
import RenderVehicleProfile from "./renderVehicleProfile";

function VehicleProfile(props) {
  const { sideBar } = props;
  let { id } = useParams();
  console.log("VehicleProfile",id);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [activeTab, setActiveTab] = useState("document");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const serviceItems = useSelector((state) => state?.fleet?.serviceItems);
    console.log("serviceItemsserviceItemsserviceItems111",serviceItems);
  const vehicleProfileData = useSelector((state) => state?.fleet?.vehicleProfileData);
  console.log("vehicleProfileData",vehicleProfileData, serviceItems);
  const { advancedVehicleList } = useSelector(
    (state) => state?.fleet
  );
  const vehicle = advancedVehicleList?.filter(
    (element) => element.fleetId == id
  )[0];
  console.log("vehicle", vehicle, id);

  useEffect(() => {
    dispatch(getVehicleProfileData({fleetId: id}, (res)=> {
        console.log("dispatchgetVehicleProfileData", res);
    }));
    dispatch(getKarzaVehicleData({fleetId: id}, (res)=> {
      console.log("dispatchgetKarzaVehicleData", res);
  }));
  },[id]);
  useEffect(() => {
    console.log("serviceItemsserviceItemsserviceItems222",serviceItems);
    if(Object.keys(serviceItems).length  == 0) {
      console.log("",serviceItems);
      dispatch(getServiceItems({}, (res)=>{
        console.log("serviceItemsserviceItemsserviceItems333",res.data);
      }))
    }
    if(!vehicle) {
      console.log("serviceItemsservivehiclevehiclevehiclevehicleceItemsserviceItems",vehicle);
      dispatch(
        advancedVehicleListAction({
          offset: 0,
          search: "",
          limit: 15,
          activeStatus:1,
          assignedStatus:3,
          minKyc: "",
          sortAs: "",
          sortBy: "",
        })
      )
    }
  }, [])
 

  return (
    <div
      className="container topMargin sideBarMargin"
      style={{
        // paddingTop:"5.5rem",
        marginLeft: sideBar ? "220px" : "100px",
        maxWidth: sideBar ? windowWidth - 240 : windowWidth - 130,
      }}
    >
      <div
        className="main1"
        style={{ height: "1200px", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", flexDirection:"row", justifyContent:"space-between" }}>
          <div>
            <h1 className="headingLow semiBold" style={{ marginBottom: "25px" }}>
              Vehicle Profile
            </h1>
          </div>
        </div>
        <div>
          <RenderVehicleProfile />
        </div>
        <div className="bottomPart">
        <div className="d-flex ">
          <button
            className={activeTab == "document" ? "activeTab tab" : "inActiveTab tab"}
            onClick={() => {
                setActiveTab("document");
            }}
          >
            Document and Permits
          </button>
          <button
            className={activeTab == "service" ? "activeTab tab" : "inActiveTab tab"}
            onClick={() => {
              setActiveTab("service");
            }}
          >
            Service and Maintainance
          </button>
          {/* <button
            className={activeTab == "tool" ? "activeTab tab" : "inActiveTab tab"}
            onClick={() => {
              setActiveTab("tool");
            }}
          >
            Tools
          </button>
          <button
            className={activeTab == "driverHistory" ? "activeTab tab" : "inActiveTab tab"}
            onClick={() => {
              setActiveTab("driverHistory");
            }}
          >
            Driver History
          </button> */}
        </div>
        {activeTab == "document" ? (
          <DocumentsAndPermits 
            vehicleDocsData={vehicleProfileData?.documentData}
            fleetId={id}
            vehicle={vehicle}
          />
        ) : activeTab == "service" ? (
          <ServiceAndMaintainance 
            vehicleServiceData={vehicleProfileData?.serviceData} 
            fleetId={id} 
            vehicle={vehicle}
          />
        ) : activeTab == "tool" ? (
          <Tools vehicleServiceData={vehicleProfileData?.serviceData} fleetId={id} />
        ) :activeTab == "driverHistory" ? (
          <DriverHistory vehicleServiceData={vehicleProfileData?.serviceData} fleetId={id} />
        ) :(
          <></>
        )}
      </div>
    </div>
    <ToastContainer
          theme="light"
          position="top-right"
          closeOnClick
          pauseOnHover
          autoClose={3000}
        />
    </div>
  );
}

export default VehicleProfile;
